import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import CommentIcon from '@mui/icons-material/Comment';
import IconButton from '@mui/material/IconButton';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/List": List, "@mui/material/ListItem": ListItem, "@mui/material/ListItemText": ListItemText, "@mui/icons-material/Comment": CommentIcon, "@mui/material/IconButton": IconButton } } });
export default ClientProvider;
